import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getSelectionById } from "../../../services/api";
import SelectionList from "./SelectionList";
import QuotationTable from "./QuotationTable";

export default function SelectionPage({ brandLogoUrl, brandName }) {
  const { selectionId } = useParams();
  const navigate = useNavigate();

  const [selectionData, setSelectionData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchSelection = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await getSelectionById(selectionId);
      setSelectionData(data);
    } catch (err) {
      console.error("Failed to fetch selection:", err);
      setError(err.message || "Failed to load selection details.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectionId) {
      fetchSelection();
    }
  }, [selectionId]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 text-gray-500 text-sm font-medium">
        Loading Selection...
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 gap-4">
        <p className="text-red-500 font-medium text-sm">{error}</p>
        <button
          onClick={fetchSelection}
          className="px-4 py-2 bg-gray-900 text-white rounded-md text-xs font-semibold"
        >
          Retry
        </button>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100/70 p-6">
      {/* Top Header Bar */}
      <div className="max-w-[1600px] mx-auto flex items-center justify-between mb-6">
        <button
          onClick={() => navigate(-1)}
          className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 text-xs font-semibold transition-colors shadow-sm"
        >
          ← Back To Visualizer
        </button>

        <div>
          {brandLogoUrl ? (
            <img
              src={brandLogoUrl}
              alt={brandName || "Logo"}
              className="h-10 max-w-44 object-contain"
            />
          ) : (
            <span className="text-xl font-extrabold tracking-wider text-gray-900">
              YOUR COMPANY <span className="block text-xs font-normal">LOGO HERE</span>
            </span>
          )}
        </div>
      </div>

      {/* Main UI Layout matching wireframe */}
      <div className="w-full h-screen p-4 bg-gray-100 flex flex-col md:flex-row gap-4 overflow-hidden box-border">
        <div className="w-full md:w-[320px] lg:w-[360px] flex-shrink-0 h-full overflow-hidden">
          <SelectionList
            areas={selectionData?.areas || selectionData?.items || []}
            totalAreaCount={selectionData?.total_area_count || selectionData?.items?.length || 0}
            totalSkuCount={selectionData?.total_sku_count || selectionData?.items?.length || 0}
            onAddMore={() => navigate(-1)}
          />
        </div>

        <div className="flex-1 h-full overflow-hidden">
          <QuotationTable
            quotation={selectionData}
            selectionId={selectionId}
            visualizerToken={selectionData?.visualizer_token}
            onDataChange={fetchSelection}
          />
        </div>
      </div>
    </div>
  );
}